export const baseUrl = "https://hrlicensurebe.dev.k8s.sandboxaddis.com/api";
export const googleApi = "https://storage.googleapis.com/hris-lisence-dev/";
